var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployeesHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.30005C15.2703 7.30005 16.3 6.2703 16.3 5.00005C16.3 3.72979 15.2703 2.70005 14 2.70005C12.7298 2.70005 11.7 3.72979 11.7 5.00005C11.7 6.2703 12.7298 7.30005 14 7.30005ZM17.2 5.00005C17.2 6.76736 15.7674 8.20005 14 8.20005C12.2327 8.20005 10.8 6.76736 10.8 5.00005C10.8 3.23274 12.2327 1.80005 14 1.80005C15.7674 1.80005 17.2 3.23274 17.2 5.00005Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2617 15.0999L21.2597 14.9518C21.2423 13.6045 20.4922 12.3357 19.1939 11.3811C17.8824 10.4167 16.0474 9.80578 14 9.80578C11.7845 9.80578 9.8198 10.521 8.49693 11.6231C7.38861 12.5464 6.75631 13.715 6.74036 14.9518L6.73845 15.0999H5.89868L5.90033 14.9483C5.9176 13.3596 6.72958 11.9505 7.98317 10.9062C9.47481 9.6635 11.628 8.8999 14 8.8999C16.1943 8.8999 18.1992 9.55309 19.6674 10.6326C21.1187 11.6998 22.081 13.2161 22.0998 14.9483L22.1014 15.0999H21.2617Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00005 25.3C3.99416 25.3 4.80005 24.4942 4.80005 23.5C4.80005 22.5059 3.99416 21.7 3.00005 21.7C2.00594 21.7 1.20005 22.5059 1.20005 23.5C1.20005 24.4942 2.00594 25.3 3.00005 25.3ZM5.70005 23.5C5.70005 24.9912 4.49122 26.2 3.00005 26.2C1.50888 26.2 0.300049 24.9912 0.300049 23.5C0.300049 22.0089 1.50888 20.8 3.00005 20.8C4.49122 20.8 5.70005 22.0089 5.70005 23.5Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 25.3C14.9942 25.3 15.8 24.4942 15.8 23.5C15.8 22.5059 14.9942 21.7 14 21.7C13.0059 21.7 12.2 22.5059 12.2 23.5C12.2 24.4942 13.0059 25.3 14 25.3ZM16.7 23.5C16.7 24.9912 15.4912 26.2 14 26.2C12.5089 26.2 11.3 24.9912 11.3 23.5C11.3 22.0089 12.5089 20.8 14 20.8C15.4912 20.8 16.7 22.0089 16.7 23.5Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 25.3C25.9942 25.3 26.8 24.4942 26.8 23.5C26.8 22.5059 25.9942 21.7 25 21.7C24.0059 21.7 23.2 22.5059 23.2 23.5C23.2 24.4942 24.0059 25.3 25 25.3ZM27.7 23.5C27.7 24.9912 26.4912 26.2 25 26.2C23.5089 26.2 22.3 24.9912 22.3 23.5C22.3 22.0089 23.5089 20.8 25 20.8C26.4912 20.8 27.7 22.0089 27.7 23.5Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55005 14.55H25.4501V20.2H24.55V15.45H14.45V20.2H13.55V15.45H3.45005V20.2H2.55005V14.55Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesHover);
export default __webpack_public_path__ + "static/media/employees-hover.f2637e2d.svg";
export { ForwardRef as ReactComponent };